/* Helpers */
import { inTz } from "../../helpers/timezone"

/* Translate */
import { t } from "../../translates/translate"


/* SUITS OF THE DECK — THE ORDER OF THE SEEDER, HEART FIRST AND SPADE LAST */
export const SUITS = ["heart", "diamond", "club", "spade"]

/* SHORT LABELS OF THE HIGH CARDS — A TILE HAS NO ROOM FOR "QUEEN" */
const RANKS = { 11: "J", 12: "Q", 13: "K", 14: "A" }


/* SUIT OF A CARD — THE NAME AND THE IMAGE COME FROM THE SEEDER, THE BARCODE IS EDITABLE AND CANNOT BE TRUSTED HERE */
export const getSuit = (item) => {

    /* Fields */
    const source = `${item.name || ""} ${item.image || ""}`.toLowerCase()

    /* Check Suits */
    const suit = SUITS.find((value) => source.includes(value))

    /* Send Result */
    return suit ? suit : "other"
}


/* SUIT OF A CARD IN WORDS */
export const getSuitName = (suit) => t(`card.suit.${suit}`)


/* SHORT RANK OF A CARD — 2..10, J, Q, K, A */
export const getRank = (item) => {

    /* Fields */
    const value = parseInt(item.value)

    /* Check Value */
    if (isNaN(value)) {
        return "?"
    }

    /* Send Result */
    return RANKS[value] ? RANKS[value] : `${value}`
}


/* BARCODE OF A CARD — AN EMPTY COLUMN IS A CARD NO SCANNER CAN READ */
export const getCode = (item) => item.barcode ? String(item.barcode).trim() : ""


/* CARDS SHARING ONE BARCODE — A SCANNER READS A CODE, NOT A NAME, SO A REPEATED CODE IS A REAL CONFLICT */
export const getDoubles = (data) => {

    /* Fields */
    const codes = {}
    const doubles = {}

    /* Count Codes */
    data.forEach((item) => {

        /* Prepare Code */
        const code = getCode(item).toUpperCase()

        /* Check Code */
        if (code !== "") {
            codes[code] = codes[code] ? codes[code] + 1 : 1
        }

    })

    /* Keep The Repeated Ones */
    Object.keys(codes).forEach((code) => {
        if (codes[code] > 1) {
            doubles[code] = codes[code]
        }
    })

    /* Send Result */
    return doubles
}


/* STATE OF A CARD — WHAT THE TILE HAS TO SHOW WITHOUT BEING OPENED */
export const getState = (item, doubles) => {

    /* Fields */
    const code = getCode(item).toUpperCase()

    /* Check Code */
    if (code === "") {
        return "empty"
    }

    /* Check Double */
    if (doubles && doubles[code]) {
        return "double"
    }

    /* Send Result */
    return "ok"
}


/* DATE OF THE LAST CHANGE */
export const formatDate = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY HH:mm")
}
